// Цвет редкости скина из API (поле color, hex без #, например "4b69ff").
// Используется для тонировки карточек скинов в рулетке и сетке кейса.

const HEX_RE = /^[0-9a-fA-F]{6}$/

export const getRarityHex = (item) => {
  const color = item?.color
  return typeof color === 'string' && HEX_RE.test(color) ? `#${color}` : null
}

export const hexToRgb = (hex) => {
  const value = hex.replace('#', '')
  return {
    r: parseInt(value.slice(0, 2), 16),
    g: parseInt(value.slice(2, 4), 16),
    b: parseInt(value.slice(4, 6), 16),
  }
}

// Подложка ячейки: мягкий градиент цвета редкости поверх surface (#14141A).
// Если color отсутствует/невалиден — возвращает undefined (остаётся bg-surface).
export const raritySurfaceStyle = (item) => {
  const hex = getRarityHex(item)
  if (!hex) return undefined
  const { r, g, b } = hexToRgb(hex)
  return {
    background: `linear-gradient(to right, rgba(${r}, ${g}, ${b}, 0.16), rgba(${r}, ${g}, ${b}, 0.04)), #14141A`,
  }
}
